/* eslint-disable react/no-unescaped-entities */
import React from 'react';

function Release20251028() {
  return (
    <section className="flex flex-col gap-4 border-b">
      <h2 className="font-gothammedium text-neutral-700">Enrichment 25/26_S13 - S16</h2>
      <p className="-mt-4">09th September 2025</p>

      <h3 className="font-gothammedium text-neutral-700">
        ✅New Features & Improvements
      </h3>
      <ul className="-mt-4">
        <li>Prism [API / UI] - Colour Matching - Logs</li>
        <li>Prism [API / UI] - Brand Grouping - Redesign</li>
        <li>Prism [API / UI] - Colour Matching - Redesign</li>
        <li>Prism [API / UI] (Size Mapping) - Add logs for Size Mapping</li>
        <li>Prism API (PLP - Export) : Add Style ID to Export All</li>
        <li>Prism [API / UI] Colour Swatches - Remove the swatch indicator from Colour swatches</li>
        <li>Prism (Categories) - Implement new logs for One Stock API Button with new Category ID (99999)</li>
        <li>Prism [API / UI] (Indexing) - Display on Dashboard if indexing jobs have been successful</li>
        <li>Prism [API / UI] (Bulk Operations) - Add UTF-8 File Validation to All bulk pages (Attributes & Product Name)</li>
      </ul>
      <h3 className="font-gothammedium text-neutral-700">🐞 Bug Fixes</h3>
      <ul className="-mt-4">
        <li>PRISM - Unable to add description if the product not having before</li>
        <li>PRISM - Brand Grouping -  Unable to add new brand to the existing brand groups</li>
        <li>PRISM - Enable stock bulk operation - One stock source stock location products status showing as "Disabled" even though products all variants are enabled</li>
        <li>PRISM - Getting Exception error message in dashboard and indexing section  showing  as empty</li>
        <li>PRISM - Bulk Operation - Enable stock - Products are displaying even though selected stock locations are not available for that products</li>
        <li>PRISM - Size UK - On site showing as "Not on site" in pdp page but products are displaying in the site</li>
      </ul>
    </section>
  );
}

export default Release20251028;
